import BaseApiClient from "./base-client";
class SitePointsApi extends BaseApiClient {
    static BASE_PATH = "/api/points";
    static instance = new SitePointsApi();
    getSitePointsConfig = () => {
        return this.get(`${SitePointsApi.BASE_PATH}/config`);
    };
    updateSitePointsConfig = (config) => {
        return this.post(`${SitePointsApi.BASE_PATH}/config`, {
            data: config
        });
    };
    adjustUserPoints = (config) => {
        return this.post(`${SitePointsApi.BASE_PATH}/adjust`, {
            data: config
        });
    };
    revokeUserPoints = (config) => {
        return this.post(`${SitePointsApi.BASE_PATH}/revoke`, {
            data: config
        });
    };
    restoreUserPoints = (config) => {
        return this.post(`${SitePointsApi.BASE_PATH}/restore`, {
            data: config
        });
    };
    getSitePointLogs = (request, myLogs) => {
        const path = myLogs ? `${SitePointsApi.BASE_PATH}/my-logs` : `${SitePointsApi.BASE_PATH}/logs`;
        return this.post(path, {
            data: request
        });
    };
}
export default SitePointsApi.instance;
